import React, { useRef } from "react"
import Observer from "@researchgate/react-intersection-observer"

const Batch = ({
  id,
  batch,
  batchIndex,
  chunksPerBatch,
  chunkLength,
  gridComponent: Grid,
  pageType,
}) => {
  const showChunks = useRef({
    ...[true, ...Array(chunksPerBatch - 1).fill(false)],
  })

  const handleObserverChange = (entry, i) => {
    if (i < chunksPerBatch && !showChunks.current[i] && entry.isIntersecting) {
      const chunkArticles = batch.slice(i * chunkLength, (i + 1) * chunkLength)
      if (chunkArticles.length > 0) {
        showChunks.current[i] = true
        document.querySelector(`#${id}-chunk-${i}`).style.display = "block"
      }
    }
  }

  const renderChunk = (i) => {
    let hide = false

    if (!showChunks.current[i]) {
      hide = true
    }

    const chunkArticles = batch.slice(i * chunkLength, (i + 1) * chunkLength)
    if (chunkArticles.length === 0) {
      hide = true
    }

    return (
      <div id={`${id}-chunk-${i}`} style={{ display: hide ? "none" : "block" }}>
        <Grid
          articles={chunkArticles}
          startIndex={batchIndex * chunksPerBatch * chunkLength + i * chunkLength}
          pageType={pageType}
        />
      </div>
    )
  }

  return (
    <div id={id}>
      {[...Array(chunksPerBatch)].map((_, i) => (
        <Observer
          key={`${id}-chunk-${batch[i * chunkLength]?.id || i}`}
          threshold={[0.3, 0.4, 0.5, 0.6, 0.7, 0.8]}
          onChange={(entry) => handleObserverChange(entry, i + 1)}
        >
          {renderChunk(i)}
        </Observer>
      ))}
    </div>
  )
}

export default Batch
